import { Tag } from '@fourthwall/components';
import React from 'react';
import * as S from './DetailsListItem.styled';
export const DetailsListItem = ({ title, subtitle, tagProps }) => (React.createElement(S.ItemContainer, null,
    React.createElement(S.Content, null,
        React.createElement(S.Title, null, title),
        React.createElement(S.Subtitle, null, subtitle)),
    tagProps && (React.createElement(S.TagContainer, null,
        React.createElement(Tag, { ...tagProps })))));
